import { Address } from "generated/graphql";

export const formatAddress = (address: Address) => {
  return address?.address?.split(",")[0] || "";
};
